import styled from 'styled-components';

export const Banner = styled.img`
    margin: 16px auto;
	displat: block;
	max-width: 100%;
`;

export const Video = styled.iframe`
    margin: 16px auto;
	displat: block;
	width: 100%;
    aspect-ratio: 4 / 3;
`;